import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawers: [
      { id: 1, title: 'Reminders' },
      { id: 2, title: 'Friends' },
      { id: 3, title: 'Work' },
      { id: 4, title: 'Travel' },
      { id: 5, title: 'Quotes' }
    ],
    hashtags: [
      { id: 1, title: 'flowchart' },
      { id: 2, title: 'followup' },
      { id: 3, title: 'hashtags' },
      { id: 4, title: 'maps' },
      { id: 5, title: 'meetings' },
      { id: 6, title: 'networking' },
      { id: 7, title: 'quotes' },
      { id: 8, title: 'relax' },
      { id: 9, title: 'reminders' },
      { id: 10, title: 'subway' },
      { id: 11, title: 'work' }
    ],
    notes: [
      { id: 1, text: 'What a nice photo I took yesterday! Oh No. #firstworldproblems', img: 'https://images.unsplash.com/photo-1559713042-410cc4949891?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=967&q=80' },
      { id: 2, text: 'What a nice photo I took yesterday! Oh No. #haha', img: 'https://images.unsplash.com/photo-1559713042-410cc4949891?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=967&q=80' },
      { id: 3, text: 'What a nice photo I took yesterday! Oh No. #snowperson', img: 'https://images.pexels.com/photos/40541/christmas-snow-snowman-decoration-40541.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' }
    ]
  },
  getters: {
    getDrawers: state => { return state.drawers },
    getHashtags: state => { return state.hashtags },
    getNotes: state => { return state.notes }
  },
  mutations: {

  },
  actions: {

  }
})
